import React, { useContext } from 'react';
import I18n from '../../I18n/I18n/I18n';
import styles from './DescriptionField.module.scss';
import WidgetSizeContext from '../WidgetSizeContext/WidgetSizeContext';
import cs from 'classnames';
export default function DescriptionField(_ref) {
  var id = _ref.id,
    className = _ref.className,
    description = _ref.description,
    escape = _ref.escape;
  var widgetSize = useContext(WidgetSizeContext);
  if (typeof description === 'string') {
    return /*#__PURE__*/React.createElement("div", {
      id: id,
      className: cs(className, styles.field, styles["field--".concat(widgetSize)])
    }, /*#__PURE__*/React.createElement(I18n, {
      i18n: description,
      escape: escape
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", {
      id: id,
      className: cs(styles.field, styles["field--".concat(widgetSize)])
    }, description);
  }
}